import { render, staticRenderFns } from "./blueWhatsapp.vue?vue&type=template&id=5f287cda"
import script from "./blueWhatsapp.vue?vue&type=script&lang=js"
export * from "./blueWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports